<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <!--  <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>

                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div> -->
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(nomePiano)="item">
                            <span>{{ item.item.nomePiano }}</span>
                        </template>
                        <template #cell(idPresidio)="item">
                            <span>{{ getNomePresidio(item.item.idPresidio) }}</span>
                        </template>
                        <template #cell(nome)="item">
                            <span>{{ item.item.nome || item.item.nomeLetto }}</span>
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" @click="onClickVisualizzaLetto(item)">
                                    <i class="bi bi-eye"></i>
                                </b-button>
                            </b-container>
                        </template>
                        <template #cell(statoAttuale)="row">
                            <!-- <b-badge pill :variant="getStatusVariant(item.item.statoAttuale)">
                                {{ item.item.statoAttuale }}
                            </b-badge> -->
                            <stati-colors-gestione-camere :statoLabel="row.item.statoAttuale || row.item.stato"> </stati-colors-gestione-camere>
                        </template>
                        <template #cell(descrizioneSesso)="item">
                            <span>{{ item.item.descrizioneSesso }}</span>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import statiColorsGestioneCamere from "../../utility/statiColorsGestioneCamere.vue";
import toast from "../../../../template/layout/utility/sa-toast";

export default {
    mixins: [UtilityMixin],
    components: { statiColorsGestioneCamere },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            items: [],
            rows: 0,
            storicoMode: false,
            perPage: 50,
            idLetto: null,
            pathResourcePresidi: "/strutturepresidi",
            currentPage: 1,
            nomePresidioOptions: [],
            pathResourceLettoStorico: "/rsapostilettolettostatistorico",
            pathResourceAggiornaStato: "/rsapostilettolettostatistorico",
            filtroGestioneCamere: {},
            filtroGestioneCamereStorico: {},
            endpoint: null,
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Presidio",
                    key: "idPresidio",
                    sortable: true,
                },
                {
                    label: "Piano",
                    key: "nomePiano",
                    sortable: true,
                },
                {
                    label: "Stanza",
                    key: "nomeStanza",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Letto",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Tipologia",
                    key: "descrizioneSesso",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadDataLetti();
        },
    },
    mounted() {
        let me = this;
        me.loadDataPresidi();
    },
    methods: {
        setParametri(path) {
            let me = this;

            if (path) {
                me.pathResource = path;
            } else {
                me.pathResource = "/rsapostilettoletti";
            }
            me.loadDataLetti();
        },
        getNomePresidio(item) {
            let me = this;
            let returnValue = null;
            if (item) {
                let filter = me.nomePresidioOptions.filter((e) => e.id === item);
                returnValue = filter;
            }
            return returnValue[0].text ? returnValue[0].text : "";
        },

        loadDataLetti() {
            let me = this;
            me.openShowModalLoading();
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneCamere"]) {
                me.filtroGestioneCamere = JSON.parse(sessionStorage["filtroGestioneCamere"]);
            }
            me.filtroGestioneCamere = { ...me.filtroGestioneCamere, page: me.currentPage, forPage: me.perPage };
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroGestioneCamere, me.loadDataLettiSuccess, me.loadDataLettiError);
            if (me.pathResource === "/rsapostilettoletti") {
                me.storicoMode = false;
            } else {
                me.storicoMode = true;
            }
        },
        loadDataLettiStorico(idLetto) {
            let me = this;
            me.idLetto = idLetto;
            let filtroStorico = { idLetto: me.idLetto };
            UtilityMixin.methods.loadDataResources(me.pathResourceLettoStorico, filtroStorico, me.loadDataLettiStoricoSuccess, me.loadDataLettiStoricoError);
            me.$emit("beforeLoadData");
        },
        loadDataLettiStoricoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = [];
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataLettiStoricoError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei letti", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataLettiSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.closeShowModalLoading();
            me.items = [];
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataLettiError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.closeShowModalLoading();
            me.$bvToast.toast("Errore durante il caricamento dei letti", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickVisualizzaLetto(item) {
            let me = this;

            if (!me.storicoMode) {
                me.$router.push("/rsagestionecamere/view/" + item.id);
            } else {
                me.$router.push("/rsagestionecamerestorico/view/" + item.idLetto);
            }
        },
        loadDataPresidi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, {}, me.loadDataPresidiSuccess, me.loadDataPresidiError);
        },
        loadDataPresidiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.nomePresidioOptions = response.data.data.list.map((item) => {
                    return { value: item.denominazione, text: item.denominazione, id: item.id };
                });
            } else {
                me.nomePresidioOptions = [];
            }
            if (me.filtroConfigurazionePostiLetto) {
                if (me.filtroConfigurazionePostiLetto.denominazionePresidio) {
                    let presidioFiltrato = me.nomePresidioOptions.find((item) => item.value === me.filtroConfigurazionePostiLetto.denominazionePresidio);
                    if (presidioFiltrato) {
                        me.filtroPiani = { idPresidio: presidioFiltrato.id };
                        me.loadDataPiani();
                    }
                }
            }
        },
        loadDataPresidiError(error) {
            console.log(error);
        },
        rendiDisponibiliLetti() {
            let me = this;
            this.openShowModalLoading();
            let lettiLiberi = me.items.filter((element) => element.statoAttuale === "LIBERO");
            if (lettiLiberi.length > 0) {
                let arrayPost = [];
                lettiLiberi.forEach((element) => {
                    arrayPost.push({ idLetto: element.id, stato: "DISPONIBILE", note: null, dataOra: new Date().getTime() });
                });
                me.saveResource(me.pathResourceAggiornaStato + "/lista", arrayPost, me.rendiDisponibiliLettiSuccess, null);
            } else {
                this.closeShowModalLoading();
                toast.info("Letti già disponibili");
            }
        },
        rendiDisponibiliLettiSuccess() {
            this.closeShowModalLoading();
            toast.success("Letti Disponibili");
            this.loadDataLetti();
        },
    },
};
</script>

<style></style>
